import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import Glosario from '../img/glosario.png';
import Normatividad from '../img/normatividad.png';

class VinculosFooter extends Component {
    render() {
      return (
        <div className="container">
            <div className="row">
                <div className="col-md-6 col-sm-12">
                    <Link to="./Glosario">
                        <div className="card">
                            <div className="row">
                                <div className="col-8">
                                    <h4>Glosario</h4>
                                    <p>Consulta el significado de las palabras más relevantes usadas en el SIJE.</p>
                                </div>
                                <div className="col-4 text-center">
                                    <img src={Glosario} alt="Logo INE"></img>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-md-6 col-sm-12">
                    <Link to="./Normatividad">
                        <div className="card">
                            <div className="row">
                                <div className="col-8">
                                    <h4>Normatividad</h4>
                                    <p>Consulta los documentos y normas que rigen el funcionamiento del SIJE.</p>
                                </div>
                                <div className="col-4 text-center">
                                    <img src={Normatividad} alt="Logo INE"></img>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
      );
    }
  }

export default VinculosFooter;